import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { CountryOutput } from 'types/api'
import { apiClient } from '../api-client'
import { SNA_PREFIX } from '@services/utils'

export const degreesQueryKey = ['degrees']

type UsePlacesArgs = {
  search: string
}

export function useDegrees(args: UsePlacesArgs) {
  const { search } = args

  const params = useMemo(
    function getParams(): URLSearchParams {
      const params = new URLSearchParams()

      if (search) {
        params.set('search', search)
      }

      return params
    },
    [search]
  )

  async function getDegrees() {
    const response = await apiClient.get<CountryOutput[]>(
      SNA_PREFIX + `degrees?${params.toString()}`
    )

    return response.data
  }

  return useQuery({
    queryFn: getDegrees,
    queryKey: [...degreesQueryKey, params.toString()]
  })
}
